module.exports = __webpack_public_path__ + "assets/closeDialogButton-b53b15.svg";